/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_UR_PK: Record<string, string> = {
    ariaAnnounceChart: 'چارٹ، ${seriesCount}[number] سیریز',
    ariaAnnounceFlowProportionLink: 'لنک ${index} کا ${count} میں سے، ${from} سے ${to} تک، ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'نوڈ ${index} کا ${count}، ${description}',
    ariaAnnounceGaugeChart: 'گیج چارٹ, ${caption}',
    ariaAnnounceHierarchyChart: 'درجہ بندی چارٹ، ${caption}',
    ariaAnnounceHierarchyDatum: 'سطح ${level}[number], ${count}[number] بچے, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'دیکھنے کے لیے اس کاپی پر اسپیس یا انٹر دبائیں',
    ariaLabelAddHorizontalLine: 'افقی لائن شامل کریں',
    ariaLabelAnnotationOptionsToolbar: 'تشریح کے اختیارات',
    ariaLabelAnnotationSettingsDialog: 'تشریح کی ترتیبات',
    ariaLabelColorPicker: 'رنگ چننے والا',
    ariaLabelFinancialCharts: 'مالی چارٹ',
    ariaLabelLegend: 'علامات',
    ariaLabelLegendItem: '${label}, لیجنڈ آئٹم ${index}[number] میں سے ${count}[number]',
    ariaLabelLegendItemUnknown: 'نامعلوم علامات کی شے',
    ariaLabelLegendPageNext: 'اگلا لیجنڈ صفحہ',
    ariaLabelLegendPagePrevious: 'پچھلا لیجنڈ صفحہ',
    ariaLabelLegendPagination: 'لیجنڈ پیجینیشن',
    ariaLabelNavigator: 'نیویگیٹر',
    ariaLabelNavigatorMaximum: 'زیادہ سے زیادہ',
    ariaLabelNavigatorMinimum: 'کم از کم',
    ariaLabelNavigatorRange: 'حد',
    ariaLabelRangesToolbar: 'حدود',
    ariaLabelSettingsTabBar: 'ترتیبات',
    ariaLabelZoomToolbar: 'زوم',
    ariaValuePanRange: '${min}[percent0to2dp] سے ${max}[percent0to2dp]',
    contextMenuDownload: 'ڈاؤن لوڈ کریں',
    contextMenuPanToCursor: 'یہاں تک گھمائیں',
    contextMenuToggleOtherSeries: 'دیگر سیریز کو ٹوگل کریں',
    contextMenuToggleSeriesVisibility: 'مرئی ہونے کو ٹوگل کریں',
    contextMenuZoomToCursor: 'یہاں زوم کریں',
    dialogHeaderChannel: 'چینل',
    dialogHeaderDatePriceRange: 'تاریخ اور قیمت',
    dialogHeaderDateRange: 'تاریخ کی حد',
    dialogHeaderFibonacciRange: 'فب ریٹریسمنٹ',
    dialogHeaderLine: 'لائن',
    dialogHeaderPriceRange: 'قیمت کی حد',
    dialogHeaderText: 'متن',
    dialogInputAlign: 'ترتیب دیں',
    dialogInputColorPicker: 'رنگ',
    dialogInputColorPickerAltText: 'متن کا رنگ',
    dialogInputExtendAbove: 'اوپر تک بڑھائیں',
    dialogInputExtendBelow: 'نیچے وسعت دیں',
    dialogInputExtendChannelEnd: 'چینل کے آخر کو بڑھائیں',
    dialogInputExtendChannelStart: 'چینل شروع کریں',
    dialogInputExtendLeft: 'بائیں جانب توسیع کریں',
    dialogInputExtendLineEnd: 'لائن کے آخر کو بڑھاؤ',
    dialogInputExtendLineStart: 'لائین کا سفر بڑھائیں',
    dialogInputExtendRight: 'دائیں بڑھائیں',
    dialogInputFibonacciBands: 'بینڈز',
    dialogInputFibonacciBandsAltText: 'فیبوناچی بینڈز',
    dialogInputFillColorPicker: 'رنگ بھریں',
    dialogInputFillColorPickerAltText: 'بھرنے کا رنگ',
    dialogInputFontSize: 'سائز',
    dialogInputFontSizeAltText: 'فونٹ سائز',
    dialogInputLineStyle: 'ڈیش',
    dialogInputPosition: 'مقام',
    dialogInputReverse: 'الٹ',
    dialogInputShowFill: 'فِل دکھائیں',
    dialogInputStrokeWidth: 'وزن',
    dialogInputStrokeWidthAltText: 'لائن کا وزن',
    iconAltTextAlignCenter: 'مرکز',
    iconAltTextAlignLeft: 'بائیں جانب',
    iconAltTextAlignRight: 'دائیں',
    iconAltTextClose: 'بند کریں',
    iconAltTextLineStyleDashed: 'لمبی لکیر والا',
    iconAltTextLineStyleDotted: 'مختصر-ڈیش',
    iconAltTextLineStyleSolid: 'ٹھوس',
    iconAltTextPositionBottom: 'نیچے',
    iconAltTextPositionCenter: 'درمیان',
    iconAltTextPositionTop: 'اوپر',
    inputTextareaPlaceholder: 'متن شامل کریں',
    measurerDateRangeBars: '${value}[number] بارز',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'حجم ${value}',
    overlayLoadingData: 'ڈیٹا لوڈ ہو رہا ہے...',
    overlayNoData: 'اظہار کے لئے کوئی ڈیٹا نہیں',
    overlayNoVisibleSeries: 'کوئی نظر آنے والی سیریز نہیں',
    overlayUnsupportedBrowser: 'نا موافق براؤزر ورژن۔ براہ کرم اپنے براؤزر کو اپ گریڈ کریں۔',
    seriesHistogramTooltipCount: '${yName} (تعداد)',
    seriesHistogramTooltipFrequency: 'تعدد',
    seriesHistogramTooltipMean: '${yName} (اوسط)',
    seriesHistogramTooltipSum: '${yName} (مجموعہ)',
    toolbarAnnotationsArrow: 'تیر',
    toolbarAnnotationsArrowDown: 'تیر نیچے',
    toolbarAnnotationsArrowUp: 'اوپر کی طرف تیر',
    toolbarAnnotationsCallout: 'کال آؤٹ',
    toolbarAnnotationsClearAll: 'سب صاف کریں',
    toolbarAnnotationsComment: 'تبصرہ',
    toolbarAnnotationsDatePriceRange: 'تاریخ اور قیمت',
    toolbarAnnotationsDateRange: 'تاریخ کی حد',
    toolbarAnnotationsDelete: 'حذف کریں',
    toolbarAnnotationsDisjointChannel: 'منقطع چینل',
    toolbarAnnotationsDragHandle: 'ٹول بار کو گھسیٹیں',
    toolbarAnnotationsFibonacciAnnotations: 'فیبوناچی',
    toolbarAnnotationsFibonacciRetracement: 'فبونیکی ریٹریسمنٹ',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'فب ٹرینڈ پر مبنی',
    toolbarAnnotationsFillColor: 'رنگ بھریں',
    toolbarAnnotationsHorizontalLine: 'افقی لکیر',
    toolbarAnnotationsLineAnnotations: 'رجحان لائنیں',
    toolbarAnnotationsLineColor: 'لائن کا رنگ',
    toolbarAnnotationsLineStrokeWidth: 'لائن کی چوڑائی',
    toolbarAnnotationsLineStyle: 'لائن کا انداز',
    toolbarAnnotationsLock: 'لاک',
    toolbarAnnotationsMeasurerAnnotations: 'پیمائش کرنے والے',
    toolbarAnnotationsNote: 'نوٹ',
    toolbarAnnotationsParallelChannel: 'متوازی چینل',
    toolbarAnnotationsPriceRange: 'قیمت کی حد',
    toolbarAnnotationsQuickDatePriceRange: 'پیمائش',
    toolbarAnnotationsSettings: 'ترتیبات',
    toolbarAnnotationsShapeAnnotations: 'تیر',
    toolbarAnnotationsText: 'متن',
    toolbarAnnotationsTextAnnotations: 'متن کے تشریحات',
    toolbarAnnotationsTextColor: 'متن کا رنگ',
    toolbarAnnotationsTextSize: 'متن کا سائز',
    toolbarAnnotationsTrendLine: 'رجحان لائن',
    toolbarAnnotationsUnlock: 'ان لاک کریں',
    toolbarAnnotationsVerticalLine: 'عمودی لکیر',
    toolbarRange1Month: '1 ماہ',
    toolbarRange1MonthAria: '1 مہینہ',
    toolbarRange1Year: '1 سال',
    toolbarRange1YearAria: '1 سال',
    toolbarRange3Months: '3ماہ',
    toolbarRange3MonthsAria: '3 ماہ',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 ماہ',
    toolbarRangeAll: 'سب',
    toolbarRangeAllAria: 'سب',
    toolbarRangeYearToDate: 'سال کی ابتدا سے',
    toolbarRangeYearToDateAria: 'سال تا حال',
    toolbarSeriesTypeCandles: 'موم بتیاں',
    toolbarSeriesTypeDropdown: 'چارٹ کی قسم',
    toolbarSeriesTypeHighLow: 'اعلی نیچ',
    toolbarSeriesTypeHLC: 'ایچ ایل سی',
    toolbarSeriesTypeHollowCandles: 'ہولو کینڈلز',
    toolbarSeriesTypeLine: 'لائن',
    toolbarSeriesTypeLineWithMarkers: 'مارکرز کے ساتھ لائن',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'قدم لائن',
    toolbarZoomPanEnd: 'آخر تک پین کریں',
    toolbarZoomPanLeft: 'بائیں طرف منتقل کریں',
    toolbarZoomPanRight: 'دائیں طرف گھمائیں',
    toolbarZoomPanStart: 'آغاز کی طرف پین کریں',
    toolbarZoomReset: 'زوم ری سیٹ کریں',
    toolbarZoomZoomIn: 'زوم ان',
    toolbarZoomZoomOut: 'زوم آؤٹ',
    tooltipPaginationStatus: '${index}[number] میں سے ${count}[number]',
};
